export enum VehicleIncidentStatusType {
  InMotion="in-motion",
  Parked="parked",
}
